export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const GET_USERS = 'GET_USERS'
export const GET_ROLE = 'GET_ROLE'
export const ROLE_SUCCESS = 'ROLE_SUCCESS'




// WEBPACK FOOTER //
// ./src/store/actions/user.js